export default __webpack_public_path__ + "static/media/setting.b577c8ce.svg";